module.exports = __webpack_public_path__ + "img/Fist_bump.b18d4565.jpg";